import { render, staticRenderFns } from "./campaignCreate.vue?vue&type=template&id=6aa95a93&scoped=true"
import script from "./campaignCreate.vue?vue&type=script&lang=js"
export * from "./campaignCreate.vue?vue&type=script&lang=js"
import style0 from "./campaignCreate.vue?vue&type=style&index=0&id=6aa95a93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa95a93",
  null
  
)

export default component.exports